export default __webpack_public_path__ + "static/media/ADA-BNB.b49636e5.svg";